const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveImageUrl(url) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) return url;
    if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
    return url;
}
